import { Stack, Typography } from "@mui/material";
import { Button } from "components/UI";
import { useFinanceSettingsStore } from "features/finances";
import { BudgetYearsTable } from "../Tables";

export const BudgetYear = () => {
  const openCreateBudgetYearModal = useFinanceSettingsStore(
    state => state.openCreateBudgetYearModal
  );

  return (
    <>
      <Stack direction="column" alignItems="center" spacing={2}>
        <Typography variant="h5" fontWeight={700}>
          Set your budget year
        </Typography>
        <Typography variant="caption">
          Take the first step towards a more fulfilling financial year by
          setting your annual budget year.
        </Typography>
        <Button onClick={openCreateBudgetYearModal}>Set budget year</Button>

        <Stack alignSelf="stretch">
          <BudgetYearsTable onboarding />
        </Stack>
      </Stack>
    </>
  );
};
